<div [id]="chartId" class="w-full h-full stacked-bar-container"></div>
